import { apiService } from "api/apiService";
import type { ClassroomGroupMeetingResource } from "api/generated";
import { AGGREGATE_MENTOR_CLASS } from "classroom/constants";
import { groupMeetingFromDto } from "meetings/group-meeting/api/mappers";
import type {
  GroupMeeting,
  GroupMeetingDto,
} from "meetings/group-meeting/types";

export const fetchMentorClassGroupMeeting = async (
  mentorClass: string,
  signal?: AbortSignal,
): Promise<GroupMeeting> => {
  const url = `/api/my-students/${encodeURIComponent(mentorClass)}/group-meeting`;

  const { data } = await apiService.get<ClassroomGroupMeetingResource>(url, {
    signal,
  });

  return groupMeetingFromDto(data as unknown as GroupMeetingDto);
};

export const fetchAllMentorClassGroupMeetings = async (
  signal?: AbortSignal,
): Promise<GroupMeeting[]> => {
  const url = `/api/my-students/${AGGREGATE_MENTOR_CLASS}/group-meeting`;

  // The aggregate endpoint returns one group meeting per mentor class, wrapped
  // in a `data` collection envelope.
  const { data } = await apiService.get<{
    data: ClassroomGroupMeetingResource[];
  }>(url, { signal });

  return data.data.map((meeting) =>
    groupMeetingFromDto(meeting as unknown as GroupMeetingDto),
  );
};
